import React from 'react';
import './index.module.less';

import Filter from '@helpers/Filter';

interface IProps {
  recordInfo: any;
}

const recordType = {
  1: '进入守护地点',
  2: '离开守护地点',
  3: '进入危险地点',
  4: '离开危险地点',
  5: '呼叫求助',
  6: '驻留'
}

const Card = (props: IProps) => {
  const { recordInfo } = props;
  const type = recordInfo?.type ? recordType[recordInfo?.type]: '';
  const userName = recordInfo?.recordUser?.userName || '';
  const date = recordInfo?.time ? Filter.date(recordInfo?.time, 'dayTime') : '';
  const position = recordInfo?.position ? JSON.parse(recordInfo?.position) : '';
  const regionName = position?.region?.name || position.bldgName || '位置';
  return (
    <div className="flex" styleName="content">
      <div styleName="title">
       { recordInfo?.type === 6 ? (userName + '在' + regionName + type) : (userName + type)  }
      </div>
      <div styleName="desc" className="els-maxtwo">
       { date + ' ' + (recordInfo?.address || '') }
      </div>
    </div>
  )
}

export default Card;